import E from "../../config/index.js";
import { ERROR_CODE as $ } from "../../constants/error.js";
import { AssetType as n } from "../../constants/url.js";
import { useConfigContext as A } from "../../contexts/config/ConfigContext.js";
import { useLanguageContext as I } from "../../contexts/language/LanguageContext.js";
import { CustomError as M } from "../../errors/customError.js";
import { underscoreLocale as R } from "../../util/i18n/helper/locale.js";
import d from "path";
import * as r from "ramda";
import { useCallback as m } from "react";
const f = E.VARIABLES.ENV, j = (h) => {
  const {
    app: s,
    category: i,
    domain: c,
    input: e,
    language: a
  } = h, p = ["v1", f, i, s, R(a), e];
  return `${c}${d.join(...p)}`;
}, x = (h = {}) => {
  const {
    presetDomain: s
  } = h, {
    language: i
  } = I(), {
    config: c
  } = A(), e = m(() => {
    const {
      pathMaker: o
    } = c;
    if (r.isNil(o))
      throw new M('config "pathMaker" is not defined', $.GENERAL.MISSING_CONFIG);
    return o;
  }, [c]), a = m((o) => {
    const t = e();
    if (s)
      return s;
    switch (o) {
      case n.Json:
        return t.domainJson;
      case n.Image:
      case n.Video:
      default:
        return t.domainAsset;
    }
  }, [e, s]), p = m((o) => {
    const t = e();
    switch (o) {
      case n.Json:
        return t.app;
      case n.Image:
      default:
        return null;
    }
  }, [e]), l = m((o, t) => r.startsWith("https://", t) || r.startsWith("http://", t) ? t : `${a(o)}v1/${f}/${o}/common/${t}`, [a]), N = m((o, t) => {
    if (r.startsWith("https://", t) || r.startsWith("http://", t))
      return t;
    const u = a(o), g = p(o), k = r.reject(r.isNil), C = ["v1", f, o, g, i, t];
    return `${u}${d.join(...k(C))}`;
  }, [i, p, a]);
  return {
    makeCommonPath: l,
    makePath: N
  };
};
export {
  x as default,
  j as makePathStatic
};
//# sourceMappingURL=useApeironPathMaker.js.map
